angular.module('zc.projects')

.directive 'zcIncentiveDetail', ->
  restrict: 'E'
  templateUrl: "/templates/projects.incentives/incentive_detail.html"
  scope:
    incentive: "="



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.incentives/incentive_detail.directive.coffee